const getSectionFromDom = (DOM, sectionId) => {
    const parser = new DOMParser()
    const newSection = parser.parseFromString(DOM, 'text/html')
    return newSection.getElementById(sectionId)
}

document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant
    const variantId = variant?.id
    const form = event.target
    const formData = new FormData(form)
    const sectionId = formData.get('section-id')
    const nutritionalInfo = document.getElementById('nutritional-info')

    console.log(variantId, sectionId, nutritionalInfo)

    if (!variantId || !sectionId || !nutritionalInfo) return

    const targetUrl = `${window.location.pathname}/?variant=${variantId}&sections=${sectionId}`
    const parser = new DOMParser()

    try {
        fetch(targetUrl)
            .then(response => response.json())
            .then(data => {
                const newNutritionalInfo = getSectionFromDom(
                    data[sectionId],
                    'nutritional-info',
                )
                nutritionalInfo.innerHTML = newNutritionalInfo.innerHTML
            })
    } catch {
        console.error('Error fetching nutritional info')
    }
})